export enum Platform {
    editor = 'EDITOR_PAGE',
    browser = 'DESKTOP_BROWSER',
    wecaht = "WECHAT_GAME",
    douyin = "BYTEDANCE_MINI_GAME",
}